import { render, staticRenderFns } from "./PushBoxCheckbox.vue?vue&type=template&id=d210046c&"
import script from "./PushBoxCheckbox.vue?vue&type=script&lang=js&"
export * from "./PushBoxCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports